<template>
  <div id="menu_artifact">
    <v-row class="d-flex" justify="center">
      <v-menu
        v-if="currentArtifact"
        v-model="showMenu"
        transition="slide-y-transition"
        absolute
        :style="position"
      >
        <v-list id="artifact_container_menu_list" rounded>
          <v-list-subheader>{{ currentArtifact.name }}</v-list-subheader>

          <v-divider></v-divider>

          <v-list-item v-for="(item, i) in menuItems" :key="i" @click="item.action">
            <template #prepend>
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
            </template>

            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item>
            <v-switch
              id="input-switch-highlight-links"
              v-model="highlightOnSelection"
              color="info"
              :label="labels.EXPLORER.HIGHLIGHT_LINKS"
              hide-details
              @update:model-value="updateHighlightAllDirectLinksOnSelectBool"
            />
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
  import { Artifact } from '@/models'
  import * as joint from '@clientio/rappid'
  import labels from '@/translations/labels.json'
  import { EventBus } from '@/event-bus'
  import { ref } from 'vue'
  import { Events } from '@/models/events.model'
  import { useTraceDataStore } from '@/stores/traceDataStore'
  import { useEventBus } from '@/utils/events'

  const currentCell = ref<joint.dia.ElementView>()
  const currentArtifact = ref<Artifact>()
  const artifactBurgerMenu = ref<joint.elementTools.Button>()
  const showMenu = ref(false)
  const position = ref('')

  const traceDataStore = useTraceDataStore()
  const highlightOnSelection = ref(traceDataStore.highlightAllDirectLinksOnSelection)

  const menuItems = [
    {
      text: labels.EXPLORER.PROPERTIES,
      icon: 'mdi-view-list-outline',
      action: (): void => {
        showProperties()
      },
    },
  ]

  useEventBus('openContainerMenuArtifact', setArtifact)

  function setArtifact(event: Events['openContainerMenuArtifact']): void {
    showMenu.value = true
    currentArtifact.value = event.currentArtifact
    artifactBurgerMenu.value = event.artifactCellDropdown
    currentCell.value = event.currentCell

    position.value = `left:${artifactBurgerMenu.value.el.getBoundingClientRect().x}px; top:${
      artifactBurgerMenu.value.el.getBoundingClientRect().y
    }px; `
  }

  // ContainerMenu actions:
  function showProperties(): void {
    if (currentArtifact.value !== undefined) {
      EventBus.emit('updatePropertiesArtifact', currentArtifact.value)
    }
  }

  function updateHighlightAllDirectLinksOnSelectBool(): void {
    if (currentCell.value !== undefined) {
      EventBus.emit('highlightAllDirectLinksOnSelectionSwitch', currentCell.value)
    }
  }
</script>
